var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "nonzero" },
            React.createElement("path", { d: "M19.5 16c.828 0 1.5-.626 1.5-1.4V12.4c0-.773-.672-1.399-1.5-1.399s-1.5.626-1.5 1.399V14.6c0 .773.672 1.399 1.5 1.399zM28.5 16c.828 0 1.5-.626 1.5-1.4V12.4c0-.773-.672-1.399-1.5-1.399s-1.5.626-1.5 1.399V14.6c0 .773.672 1.399 1.5 1.399z" }),
            React.createElement("path", { d: "M31.777 13H31v1.484c0 1.34-1.179 2.428-2.565 2.428A2.406 2.406 0 0126 14.484V13h-4v1.484a2.406 2.406 0 01-2.434 2.428c-1.387 0-2.566-1.089-2.566-2.428V13h-.777C14.443 13 13 14.393 13 16.112v14.776C13 32.607 14.443 34 16.223 34h15.554C33.557 34 35 32.607 35 30.888V16.112C35 14.393 33.557 13 31.777 13zM32 29.69c0 .734-.651 1.331-1.451 1.331H17.45c-.8 0-1.451-.597-1.451-1.331v-9.907h16v9.907z" }))));
});
